import React, { useRef } from 'react';
import ScoreStar from '../assets/score-star-full.svg';
import { Container, ScoreRow, StarIcon, Score, ReviewCount } from './score-reviews.style';

interface ScoreReviewsProps {
    score: number;
    reviewCount: number;
    type: 'srp' | 'vip';
    isMobile?: boolean;
}

const ScoreReviews: React.FC<ScoreReviewsProps> = ({ score, reviewCount, type, isMobile }) => {
    const navRef = useRef<HTMLElement>(null);

    return (
        <Container id='srp-review-info' type={type} isMobile={isMobile} onClick={() => {
            if (type === 'vip') {
                const ReviewTabId = '5';
                const element = document.getElementById(ReviewTabId);
                const stickyOffset = 50; // 50px is the height of the sticky tab navigation
                if (element) {
                    const currentNavHeight = navRef.current?.offsetHeight ?? 0;
                    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - currentNavHeight - stickyOffset + 5; // 5 extra space
    
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth',
                    });
                }
            }
        }}>
            <ScoreRow>
                <StarIcon>
                    <ScoreStar />
                </StarIcon>
                <Score>{score.toFixed(1)}</Score>
            </ScoreRow>
            <ReviewCount type={type}>({reviewCount} reviews)</ReviewCount>
        </Container>
    );
};

export default ScoreReviews;
